import React from 'react';
import { useIntl } from 'react-intl';
import { Calendar, Trophy, Users } from 'lucide-react';

const FeatureCard = ({ icon, titleId, descriptionId }) => {
  const intl = useIntl();
  return (
    <div className="bg-white p-6 rounded-lg shadow-md">
      <div className="text-indigo-600 mb-4">{icon}</div>
      <h3 className="text-xl font-semibold mb-2">{intl.formatMessage({ id: titleId })}</h3>
      <p className="text-gray-600">{intl.formatMessage({ id: descriptionId })}</p>
    </div>
  );
};

const Features = () => {
  const intl = useIntl();
  return (
    <section className="py-12 bg-gray-100">
      <div className="container mx-auto px-4">
        <h2 className="text-3xl font-bold text-center text-indigo-800 mb-12">
          {intl.formatMessage({ id: 'home.features.title' })}
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <FeatureCard
            icon={<Calendar className="h-10 w-10" />}
            titleId="features.dailyChallenges.title"
            descriptionId="features.dailyChallenges.description"
          />
          <FeatureCard
            icon={<Trophy className="h-10 w-10" />}
            titleId="features.leaderboards.title"
            descriptionId="features.leaderboards.description"
          />
          <FeatureCard
            icon={<Users className="h-10 w-10" />}
            titleId="features.community.title"
            descriptionId="features.community.description"
          />
        </div>
      </div>
    </section>
  );
};

export default Features;